//                                                  
import { repo } from '@bi/sync';
export const TMTasksRepository = repo.tm.TMTasksRepository;
